import { render } from "./access-code.vue?vue&type=template&id=5272c80a"
import script from "./access-code.vue?vue&type=script&lang=js"
export * from "./access-code.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__